import $ from 'jquery';
import _ from 'underscore';

import ActivityCollection from 'collections/activity';
import ActivityLogCollection from 'collections/activity_log';
import ChartsView from 'views/charts';
import JournalCollection from 'journal/collections/journal_log';
import LoadingView from 'core/views/loading';
import MoodCollection from 'mood/collections/mood_log';
import MoodBoosterCollection from 'collections/mood_booster';
import MoodBoostersView from 'views/mood_boosters';
import PopularActivitiesChartView from 'views/popular_activities_chart';
import ScreenerPageView from 'screener/views/page';
import ScreenerSetItemCollection from 'screener/collections/screener_set_item';


export default ScreenerPageView.extend({
  events: {
    'click #seven-day-btn': 'show_weekly_chart',
    'click #thirty-day-btn': 'show_monthly_chart',
    'click #strengths-list a': 'prevent_default'
  },

  initialize: function (options) {
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.loadingView = new LoadingView({ el: $('body') });
    this.loadingView.show();

    // Templates
    this.mood_trend_template = _.template($('#mood-trend-template').html());
    this.activity_trend_template = _.template($('#activity-trend-template').html());

    // Member variables
    this.chartType = options.chartType;
    this.controller = options.controller;
    this.working_for_you = $('.working-for-you', this.el);
    this.historic_ave_mood = null;
    this.historic_ave_activities = null;

    // Collections
    this.activity_collection = new ActivityCollection();
    this.activity_log_collection = new ActivityLogCollection();
    this.mood_collection = new MoodCollection();
    this.journal_collection = new JournalCollection();
    this.mood_booster_collection = new MoodBoosterCollection();
    this.screener_set_item_collection = new ScreenerSetItemCollection();

    this.seven_day_btn = this.$el.find('#seven-day-btn');
    this.thirty_day_btn = this.$el.find('#thirty-day-btn');
    this.chart_buttons = this.seven_day_btn.add(this.thirty_day_btn);
  },

  render: function () {
    this.chartView = new ChartsView({
      chartType: this.chartType,
      controller: this.controller,
      parentView: this
    });

    $.when(this.activity_collection.fetch(),
      this.activity_log_collection.fetch(),
      this.mood_collection.fetch(),
      this.journal_collection.fetch(),
      this.mood_booster_collection.fetch(),
      this.screener_set_item_collection.fetch()).then(this.renderWithData);
  },

  renderWithData: function () {
    this.mood_booster_collection.calculate_top_boosters();
    // Setup screeners for this page
    this.create_screener_views();
    _.each(this.screener_views, function (screenerView) {
      screenerView.on('screener-results', function (userProgress) {
        // Hide screener link after it has been taken
        var ssi = this.screener_set_item_collection.findWhere({
          resource_uri: userProgress.get('screener_set_item')
        });
        if (ssi) {
          $('#screener-list-' + ssi.get('id')).addClass('hide');
        }
        // If no more due screeners are visible, revert to the
        // default text and hide the screeners due block.
        var screenersDue = $('#screeners-due');
        var stillVisible = $('.screener-list-item:not(.hide)', screenersDue);
        if (stillVisible.length === 0) {
          screenersDue.addClass('hide');
          $('#default-plan-sidebar').removeClass('hide');
        }
      }.bind(this));
    });
    this.update_historical_stats();

    // Popular charts
    this.popular_chart_view = new PopularActivitiesChartView({
      el: $('#popular-activities', this.el),
      parent_view: this
    });
    this.popular_chart_view.render();

    // Biggest mood boosters
    this.mood_boosters_view = new MoodBoostersView({
      el: $('#elevating-activities', this.el),
      collection: this.activity_collection,
      parent_view: this, date_nav: this.chartView.date_nav
    });
    this.mood_boosters_view.render();

    // Update the chart with the data for the current period
    this.chartView.update();

    this.loadingView.hide();
  },

  update_historical_stats: function () {
    var self = this;

    // Compute historic averages, just once
    this.historic_ave_activities = this.activity_log_collection.average();
    // Average Mood Rating
    this.historic_ave_mood = this.mood_collection.average();
    // Total Activities Tracked
    this.total_activities_tracked = this.activity_log_collection.length;
    // Peak Mood/Days At Peak
    var peak_moods = this.mood_collection.clone();
    peak_moods.comparator = 'mood';
    peak_moods.sort();
    var peak_mood_obj = peak_moods.at(peak_moods.length - 1);
    this.peak_mood = peak_mood_obj ? peak_mood_obj.get('mood') : 0;
    var days_at_peak_list = [];
    peak_moods.each(function (mood_log) {
      // Filter the collection to contain only moods that equal the
      // peak, and no duplicate dates.
      if (mood_log.get('mood') == self.peak_mood &&
                      !_.contains(days_at_peak_list, mood_log.get('date'))) {
        days_at_peak_list.push(mood_log.get('date'));
      }
    });
    this.days_at_peak = days_at_peak_list.length;
    // Total days tracked
    var daysTracked = [];
    var logs = this.activity_log_collection.models.concat(
      this.mood_collection.models);
    logs.forEach(function (logItem) {
      if (!_.contains(daysTracked, logItem.get('date'))) {
        daysTracked.push(logItem.get('date'));
      }
    });
    this.total_days_tracked = daysTracked.length;


    // Update historic stat elements
    $('#total-days-tracked span', this.el).html(this.total_days_tracked);
    $('#total-average-mood-rating span', this.el).html(
      this.historic_ave_mood !== null ? this.historic_ave_mood : 'N/A');
    $('#total-activities-tracked span', this.el).html(this.total_activities_tracked);
    $('#peak-mood-per-days-at-peak span', this.el).html(
      this.peak_mood + '/' + this.days_at_peak);
  },

  showChart: function (chartType) {
    this.chartView.switchChartType(chartType);
    this.chart_buttons.removeClass('active');
    if (chartType == 'week') {
      this.seven_day_btn.addClass('active');
    } else {
      this.thirty_day_btn.addClass('active');
    }
    this.controller.navigate('type/' + chartType, {
      trigger: true, replace: true });

    $('.pager-date').removeClass('temp');
  },

  show_weekly_chart: function () {
    this.showChart('week');
  },

  show_monthly_chart: function () {
    this.showChart('month');
  },
});



// WEBPACK FOOTER //
// ./static/js/views/your_chart.js